module.exports = __webpack_public_path__ + "1dbe5d1a97a4f53761b2ea624dc5e2f8.png";


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/layouts/PageLayout/CIB_es_kartyalogok_85px_vrt_HU.png
// module id = 1069
// module chunks = 20